import { all, put, takeEvery, call } from 'redux-saga/effects';
import actions from './actions';
import { getRequest } from '../../../../helpers/axiosClient';

export function* getYounoteAdminDashboard(params) {
    try {
        let response = yield call(() => getRequest(params.url));
        yield put({
            type: actions.YOUNOTE_ADMIN_DASHBOARD_SUCCESS,
            payload: response?.data
        });
    } catch (error) {
        yield put({ type: actions.YOUNOTE_ADMIN_DASHBOARD_FAILURE, message: error?.response?.data });
        return error;
    }
}

export default function* younoteAdminDashboardSaga() {
    yield all([
        takeEvery(actions.YOUNOTE_ADMIN_DASHBOARD_START, getYounoteAdminDashboard)
    ]);
}